<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-10-08 14:26:03
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-08 15:04:44
 * @FilePath: \crm-product\found\views\mdm\views\terminal_info\process\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import Form, { formCreate } from '../../../../../components/form';
import request from '../../../../../utils/request';
import Maps from '../tencent_map/index';

formCreate.component('Maps', Maps);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  props: {
    id: String,
  },
  data() {
    return {
      rule: [],
    };
  },
  async created() {
    await this.getFormRule('terminal_scan_address', 'CRM20201127000000110');
    this.init();
  },

  mounted() {},
  methods: {
    init() {
      request
        .post('/mdm/mdmterminalchangeaddress/query', { id: this.id })
        .then((res) => {
          if (res.success) {
            const { result } = res;
            const mapInfo = {
              oldLatitude: result.oldLatitude,
              oldLongitude: result.oldLongitude,
              newLatitude: result.newLatitude,
              newLongitude: result.newLongitude,
              distance: result.distance,
            };
            this.setValue({
              ...result,
              Maps: mapInfo,
            });
          }
        });
    },
  },
};
</script>
